import { endpoints } from '@rossum/api-client';
import { Run, RunsQuery } from '@rossum/api-client/hooks';
import { api } from '../../../../../lib/apiClient';
import { useNewItemsCheck } from '../../../../../utils/hooks/useNewItemsCheck';

export const QUERY_KEY_NEW_ACTIVITIES_CHECK = 'hooks-runs-new-check';

type UseNewActivitiesCheckParams = {
  latestKnownUuid: string | undefined;
  activitiesQuery: Omit<RunsQuery, 'page' | 'pageSize'>;
  enabled: boolean;
  onNewActivities: () => void;
};

export const useNewActivitiesCheck = ({
  latestKnownUuid,
  activitiesQuery,
  enabled,
  onNewActivities,
}: UseNewActivitiesCheckParams) => {
  return useNewItemsCheck<Run, Omit<RunsQuery, 'page' | 'pageSize'>>({
    queryKey: QUERY_KEY_NEW_ACTIVITIES_CHECK,
    queryFn: query =>
      api.request(
        endpoints.hooks.runs({
          ...query,
          pageSize: 1,
        })
      ),
    getId: item => item.uuid,
    query: activitiesQuery,
    latestKnownId: latestKnownUuid,
    enabled,
    onNewItems: onNewActivities,
  });
};
